exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results-count {\n  position: absolute;\n  bottom: 1.2rem;\n  margin-left: 2.5rem;\n  color: #777777;\n  font-size: 1.3rem; }\n", ""]);

// exports
